import { CatalogUrlParams } from "../schema/catalog.schema"

export const createCatalogUrlParams = (query: CatalogUrlParams) => {
	const { sort, page = 1 } = query
	const [order, direction] = sort?.split(`|`) || []

	return {
		limit: `32`,
		order: order || `popular`,
		...(page && { page: `${page}` }),
		...(direction && { direction })
	}
}
